var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MatDialogRef } from "@angular/material";
import { utils } from "vebto-client/core/services/utils";
import { Projects } from '../../../shared/projects/projects.service';
import { ProjectUrl } from '../../../shared/projects/project-url.service';
import { PageDocument } from '../../../shared/page-document';
import { Templates } from "../../../shared/templates/templates.service";
var NewProjectModalComponent = /** @class */ (function () {
    /**
     * NewProjectModalComponent Constructor.
     */
    function NewProjectModalComponent(dialogRef, data, projects, templates, projectUrl) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.projects = projects;
        this.templates = templates;
        this.projectUrl = projectUrl;
        /**
         * New project model.
         */
        this.newProject = {};
        /**
         * Errors from backend.
         */
        this.errors = {};
        this.pageDocument = new PageDocument();
        /**
         * Whether backend request is currently in progress.
         */
        this.loading = false;
        this.newProject.uuid = utils.randomString(36);
        this.pageDocument.setBaseUrl(this.projectUrl.getBaseUrl((this.newProject)));
    }
    /**
     * Create a new project.
     */
    NewProjectModalComponent.prototype.confirm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        if (!this.data.templateName) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createProjectFromTemplate()];
                    case 1:
                        params = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        params = this.createBlankProject();
                        _a.label = 3;
                    case 3:
                        this.projects.create(params).subscribe(function (response) {
                            _this.loading = false;
                            _this.dialogRef.close(response.project);
                        }, function (response) {
                            _this.loading = false;
                            _this.errors = response.messages;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Close the modal.
     */
    NewProjectModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    /**
     * Get payload for new project created from a template.
     */
    NewProjectModalComponent.prototype.createProjectFromTemplate = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var params = _this.getBasePayload();
            _this.templates.get(_this.data.templateName).subscribe(function (response) {
                params.template = response.template;
                params.framework = response.template.config.framework;
                params.pages = _this.transformTemplatePages(response.template);
                resolve(params);
            });
        });
    };
    /**
     * Get payload for new project without a template.
     */
    NewProjectModalComponent.prototype.createBlankProject = function () {
        var params = this.getBasePayload();
        params.pages.push({
            name: 'index',
            html: this.pageDocument.generate().getOuterHtml()
        });
        return params;
    };
    /**
     * Transform template pages into project pages.
     */
    NewProjectModalComponent.prototype.transformTemplatePages = function (template) {
        var _this = this;
        return template.pages.map(function (page) {
            return {
                name: page.name,
                html: _this.pageDocument.generate(page.html, template).getOuterHtml(),
            };
        });
    };
    /**
     * Get base payload for creating new project.
     */
    NewProjectModalComponent.prototype.getBasePayload = function () {
        return {
            name: this.newProject.name,
            uuid: this.newProject.uuid,
            pages: [],
            framework: 'bootstrap-3',
            template: null,
        };
    };
    return NewProjectModalComponent;
}());
export { NewProjectModalComponent };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/app/dashboard/new-project-page/new-project-modal/new-project-modal.component.ts.pre-build-optimizer.js